module.exports = __webpack_public_path__ + "static/media/icon-cart.c7f33ea5.svg";